import React from 'react';
import { User } from 'lucide-react';

// Physical-style Malaysian vocational license (PSV/GDL) card.
export const VocationalLicenseCardMY = ({ result, vl }) => {
  const icNoDash = result.ic.replace(/-/g, '');
  return (
    <div
      data-testid="vocational-license-card"
      style={{
        position: 'relative',
        background: '#f7f2d8',
        border: '2px solid #c8a800',
        borderRadius: '10px',
        overflow: 'hidden',
        maxWidth: '600px',
        fontFamily: 'Arial, sans-serif',
        backgroundImage: `repeating-linear-gradient(45deg,transparent,transparent 9px,rgba(160,130,30,0.07) 9px,rgba(160,130,30,0.07) 10px),
                          repeating-linear-gradient(-45deg,transparent,transparent 9px,rgba(160,130,30,0.07) 9px,rgba(160,130,30,0.07) 10px)`
      }}
    >
      {/* HEADER */}
      <div style={{
        background: 'rgba(252,248,228,0.97)',
        borderBottom: '2px solid #b8a000',
        padding: '10px 14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '8px'
      }}>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Coat_of_arms_of_Malaysia.svg/200px-Coat_of_arms_of_Malaysia.svg.png"
          alt="Jata Negara"
          style={{ width: 58, height: 58, objectFit: 'contain' }}
        />
        <div style={{ textAlign: 'center', flex: 1 }}>
          <div style={{ fontSize: '18px', fontWeight: '900', color: '#0d0d0d', letterSpacing: '0.5px', lineHeight: 1.15 }}>
            LESEN VOKASIONAL MALAYSIA
          </div>
          <div style={{ fontSize: '12px', fontStyle: 'italic', color: '#444', marginTop: '2px' }}>
            MALAYSIAN VOCATIONAL LICENCE
          </div>
        </div>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Flag_of_Malaysia.svg/255px-Flag_of_Malaysia.svg.png"
          alt="Malaysia"
          style={{ width: 64, height: 38, objectFit: 'cover', border: '1px solid #bbb', borderRadius: '2px' }}
        />
      </div>

      {/* BODY */}
      <div style={{ display: 'flex', gap: '14px', padding: '14px 16px' }}>
        {/* Photo */}
        <div style={{
          width: 120, height: 150, flexShrink: 0,
          border: '1px solid #999', borderRadius: '3px',
          overflow: 'hidden', backgroundColor: '#d8cfaa'
        }}>
          {result.photo ? (
            <img
              src={result.photo}
              alt="Gambar"
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }}
            />
          ) : (
            <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#888' }}>
              <User size={36} />
              <span style={{ fontSize: '10px', marginTop: '4px', textAlign: 'center' }}>GAMBAR<br/>PHOTO</span>
            </div>
          )}
        </div>

        {/* Details */}
        <div style={{ flex: 1 }}>
          {/* Name */}
          <div style={{ fontSize: '17px', fontWeight: '900', color: '#0d0d0d', marginBottom: '12px', letterSpacing: '0.3px', lineHeight: 1.2 }}>
            {result.name}
          </div>

          {/* Grid: Warganegara | No. Pengenalan */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: '1px', columnGap: '10px', marginBottom: '10px' }}>
            <div style={{ fontSize: '10px', color: '#666', fontStyle: 'italic' }}>Warganegara / Nationality</div>
            <div style={{ fontSize: '10px', color: '#666', fontStyle: 'italic' }}>No. Pengenalan / Identity No.</div>
            <div style={{ fontSize: '14px', fontWeight: '700', color: '#0d0d0d' }}>MALAYSIA</div>
            <div style={{ fontSize: '13px', fontWeight: '700', color: '#0d0d0d', letterSpacing: '1px' }}>{icNoDash}</div>

            <div style={{ fontSize: '10px', color: '#666', fontStyle: 'italic', marginTop: '6px' }}>Tempoh / Validity</div>
            <div style={{ fontSize: '10px', color: '#666', fontStyle: 'italic', marginTop: '6px' }}>Tarikh Lahir / Date Of Birth</div>
            <div style={{ fontSize: '13px', fontWeight: '700', color: '#0d0d0d' }}>{vl.issueDate} - {vl.expiryDate}</div>
            <div style={{ fontSize: '13px', fontWeight: '700', color: '#0d0d0d' }}>{result.dob}</div>
          </div>

          {/* Jenis/Type */}
          <div style={{ marginBottom: '4px' }}>
            <span style={{ fontSize: '11px', color: '#666', fontStyle: 'italic' }}>Jenis / Type </span>
            <span style={{ fontSize: '12px', fontWeight: '700', color: '#0d0d0d' }}>Kelas {vl.jenisKelas || 'PV, GDL'}</span>
          </div>

          {/* PSV class line */}
          <div style={{ fontSize: '17px', fontWeight: '900', color: '#0d0d0d', letterSpacing: '1.5px', marginTop: '2px' }}>
            {vl.jenis}&nbsp;&nbsp;&nbsp;{vl.jenisKenderaan}
          </div>
        </div>
      </div>

      {/* BOTTOM STRIP */}
      <div style={{
        height: '22px',
        background: 'rgba(184,160,0,0.18)',
        backgroundImage: `repeating-linear-gradient(45deg,transparent,transparent 4px,rgba(160,130,30,0.15) 4px,rgba(160,130,30,0.15) 5px)`
      }} />
    </div>
  );
};

export default VocationalLicenseCardMY;
